import { gql, TypedDocumentNode } from "@apollo/client";

import { SpaceliftVcs, MutationSpaceliftVcsCreateArgs } from "types/generated";

import { SPACELIFT_VCS_REPO_BASIC_FRAGMENT } from "../gql";

export const CREATE_SPACELIFT_VCS_REPO: TypedDocumentNode<
  { spaceliftVCSCreate: SpaceliftVcs },
  MutationSpaceliftVcsCreateArgs
> = gql`
  mutation CreateSpaceliftVcsRepo($input: SpaceliftVCSCreateInput!) {
    spaceliftVCSCreate(input: $input) {
      ...SpaceliftVcsRepoBasic
    }
  }
  ${SPACELIFT_VCS_REPO_BASIC_FRAGMENT}
`;
